import { render } from "./UnlimiterView.vue?vue&type=template&id=36bd97a8"
import script from "./UnlimiterView.vue?vue&type=script&lang=js"
export * from "./UnlimiterView.vue?vue&type=script&lang=js"

import "./UnlimiterView.vue?vue&type=style&index=0&id=36bd97a8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__